// import {fetch} from '_app/middleware'

// Actions
const CREATE_ACCOUNT = 'portal-web/onboarding/CREATE_ACCOUNT'; // This is only an example, will need to understand intended working API
const ENTER_ONBOARDING = 'portal-web/onboarding/ENTER_ONBOARDING';
const LOAD_REGISTRATION_ID = 'LOAD_REGISTRATION_ID';
const STORE_DISCOUNT_CODE = 'STORE_DISCOUNT_CODE';
const STORE_STRIPE_AMOUNT = 'STORE_STRIPE_AMOUNT';
const STORE_NCES_DISTRICT_ID = 'STORE_NCES_DISTRICT_ID';
const STORE_NCES_SCHOOL_ID = 'STORE_NCES_SCHOOL_ID';

// Reducer
export function reducer(state = {}, action = {}) {
  switch (action.type) {
    case ENTER_ONBOARDING:
      return {
        step: 1, // todo
      };
    case LOAD_REGISTRATION_ID: {
      return {
        ...state,
        registrationId: action.registrationId,
      };
    }
    case STORE_DISCOUNT_CODE: {
      return {
        ...state,
        discountCode: action.discountCode,
      };
    }
    case STORE_STRIPE_AMOUNT: {
      return {
        ...state,
        stripeAmount: action.stripeAmount,
      };
    }
    case STORE_NCES_DISTRICT_ID: {
      return {
        ...state,
        ncesDistrictId: action.ncesDistrictId,
      };
    }
    case STORE_NCES_SCHOOL_ID: {
      return {
        ...state,
        ncesSchoolId: action.ncesSchoolId,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export function createAccount({ emailAddress, password }) {
  return { type: CREATE_ACCOUNT };
}

export function loadRegistrationId(registrationId) {
  return {
    type: LOAD_REGISTRATION_ID,
    registrationId,
  };
}

export function storeDiscountCode(discountCode) {
  return {
    type: STORE_DISCOUNT_CODE,
    discountCode,
  };
}

export function storeStripeAmount(stripeAmount) {
  return {
    type: STORE_STRIPE_AMOUNT,
    stripeAmount,
  };
}

export function storeNcesDistrictId(ncesDistrictId) {
  return {
    type: STORE_NCES_DISTRICT_ID,
    ncesDistrictId,
  };
}

export function storeNcesSchoolId(ncesSchoolId) {
  return {
    type: STORE_NCES_SCHOOL_ID,
    ncesSchoolId,
  };
}

export function loadNCESData({
  districtName,
  schoolName,
  physicalAddress,
  orgFound,
}) {
  // FIXME this is wrong qk
  return {
    type: 'LOAD_NCES_DATA',
    payload: { districtName, schoolName, physicalAddress, orgFound },
  };
}



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/onboarding.duck.js